import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { useParams, useNavigate } from 'react-router-dom';
const categories = [{
  key: 'residential',
  label: 'Residential'
}, {
  key: 'commercial',
  label: 'Commercial'
}, {
  key: 'recreational',
  label: 'Recreational'
}];
export function Projects() {
  const {
    category
  } = useParams();
  const navigate = useNavigate();
  const activeCategory = categories.some(c => c.key === category) ? category as string : 'residential';
  const activeLabel = categories.find(c => c.key === activeCategory)?.label ?? 'Projects';
  return <main className="pt-32 pb-24 min-h-screen bg-bg-warm" data-id="element-229">
      {/* Header */}
      <div className="max-w-7xl mx-auto px-4 md:px-6 mb-16 md:mb-24" data-id="element-230">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6
      }} data-id="element-231">
          <div className="flex flex-col md:flex-row md:items-end justify-between gap-6" data-id="element-232">
            <h1 className="text-3xl md:text-4xl lg:text-5xl font-light text-primary leading-tight tracking-tight" data-id="element-233">
              Selected <span className="text-accent" data-id="element-234">Projects</span>
            </h1>

            <div className="flex space-x-6 md:pb-3" data-id="element-235">
              {categories.map(cat => <button key={cat.key} onClick={() => navigate(`/projects/${cat.key}`)} className={`uppercase tracking-widest text-sm font-light transition-colors pb-1 border-b ${activeCategory === cat.key ? 'text-accent border-accent' : 'text-text-muted border-transparent hover:text-primary'}`} data-id="element-236">
                  {cat.label}
                </button>)}
            </div>
          </div>
        </motion.div>
      </div>

      {/* Coming soon placeholder (work in progress) */}
      <AnimatePresence mode="wait" data-id="element-237">
        <motion.div key={activeCategory} initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} exit={{
        opacity: 0
      }} transition={{
        duration: 0.5,
        ease: [0.16, 1, 0.3, 1]
      }} className="max-w-7xl mx-auto px-4 md:px-6" data-id="element-238">
          <div className="border border-neutral-200 py-24 md:py-32 flex flex-col items-center text-center" data-id="element-239">
            <span className="text-accent uppercase tracking-widest text-sm font-light mb-6" data-id="element-240">
              {activeLabel}
            </span>
            <h2 className="text-3xl md:text-4xl lg:text-5xl font-light text-primary leading-tight tracking-tight mb-6" data-id="element-241">
              Coming <span className="text-accent" data-id="element-242">Soon</span>
            </h2>
            <p className="text-text-muted text-lg font-light leading-relaxed max-w-md" data-id="element-243">
              We&rsquo;re curating this collection. Our{' '}
              {activeLabel.toLowerCase()} projects will be published here soon.
            </p>
          </div>
        </motion.div>
      </AnimatePresence>
    </main>;
}